import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
//import isEmpty from 'lodash/isEmpty';

import { Collapsible } from '../../../components/index.js';
//import Label from '../../../components/ncss/Label';
import TrfInfo from '../trfInfo/TrfInfo.js';
import Remediation from '../../trf_review/Remediation/Remediation.js';
//import qrf from '../../../reducers/qrfReducer.js';
import get from 'lodash/get';

const style = {
  fontWeight: '800',
  fontSize: '1.8rem',
  lineHeight: '1.5',
  color: '#0078B9'
};

class ReviewAndSubmitInfo extends Component {
  componentDidMount() {
    const { displaySubmitButtonQrf, displayClearButtonQrf } = this.props;
    displaySubmitButtonQrf(true);
    displayClearButtonQrf(false);
  }

  render() {
    const {
      // remove commented after test
      //affectedMaterial,
      // materialAffectedQty,
      // materialWorth,
      // affectedMaterialLeft,
      // factoryList,
      // affectedMaterialForKid,
      // immediateStep,
      displaySubmitButtonQrf,
      displayClearButtonQrf,
      attachment,
      qrfDetails,
      frfDetails
    } = this.props;
    return (
      <div className="form">
        <div>
          <Collapsible
            trigger={
              <div className="ncss-col-sm-12 collapse-p0">
                <div className="ncss-col-sm-11 collapse-p0"> TRF INFORMATION</div>
                <div className="ncss-col-sm-1 ">
                  <i className="fas fa-caret-down fa-pull-right" />
                </div>
              </div>
            }
            triggerWhenOpen={
              <div className="ncss-col-sm-12 collapse-p0">
                <div className="ncss-col-sm-11 collapse-p0"> TRF INFORMATION</div>
                <div className="ncss-col-sm-1">
                  <i className="fas fa-caret-up fa-pull-right" />
                </div>
              </div>
            }
            triggerStyle={style}
            triggerClassName="collapsible"
          >
            <TrfInfo
              from="review"
              displaySubmitButtonQrf={displaySubmitButtonQrf}
              displayClearButtonQrf={displayClearButtonQrf}
              showTitle={false}
            />
          </Collapsible>
        </div>
        {/* <div>
          <Collapsible
            trigger={
              <div className="ncss-col-sm-12 collapse-p0">
                <div className="ncss-col-sm-11 collapse-p0"> QRF INFORMATION</div>
                <div className="ncss-col-sm-1 ">
                  <i className="fas fa-caret-down fa-pull-right" />
                </div>
              </div>
            }
            triggerWhenOpen={
              <div className="ncss-col-sm-12 collapse-p0">
                <div className="ncss-col-sm-11 collapse-p0"> QRF INFORMATION</div>
                <div className="ncss-col-sm-1">
                  <i className="fas fa-caret-up fa-pull-right" />
                </div>
              </div>
            }
            triggerStyle={style}
            triggerClassName="collapsible"
          >
            <div className="pl8-sm">
              <div className="ncss-row">
                <Label className="ncss-col-sm-3 pb3-sm u-bold description">
                  Has any of the <br /> affected material left <br /> the manufacturer&rsquo;s <br /> facility?
                </Label>
                <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {affectedMaterialLeft? (
                    <span>{affectedMaterialLeft}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-3 pb3-sm u-bold description">
                  Where is the affected <br /> material now?
                </Label>
                <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {affectedMaterial? <span>{affectedMaterial}</span> : 'Not Added'}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-3 pb3-sm u-bold description">
                  How much material <br /> is affected by this <br /> failure?
                </Label>
                <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {materialAffectedQty? (
                    <span>{materialAffectedQty}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-3 pb3-sm u-bold description">
                How much is the <br /> material worth?
                </Label>
                <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {materialWorth? (
                    <span>{materialWorth}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>

              <div className="ncss-row">
                <Label className="ncss-col-sm-3 pb3-sm u-bold description">
                  List all factory(s) that <br /> are expecting to <br /> receive this material
                </Label>
                <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {factoryList? <span>{factoryList}</span> : 'Not Added'}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-3 pb3-sm u-bold description">
                  Is this affected <br /> material used for Kid <br /> product
                </Label>
                <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {affectedMaterialForKid? (
                    <span>{affectedMaterialForKid}</span>
                  ) : (
                    'Not Added'
                  )}
                </Label>
              </div>
              <div className="ncss-row">
                <Label className="ncss-col-sm-3 pb3-sm u-bold description">
                  Describe your <br /> immediate next <br /> steps:
                </Label>
                <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
                  {immediateStep? <span>{immediateStep}</span> : 'Not Added'}
                </Label>
              </div>
              <div className="ncss-row">
            <Label className="ncss-col-sm-3 pb3-sm u-bold description">
             Attachment
            </Label>
            <Label className="ncss-col-sm-9 text-color-primary-dark u-bold page-title-has-back p2-left-sm">
              {!isEmpty(attachment) ? <div >{attachment.map(data =>(<div>{data.fileName}</div>))}</div> : 'Not Added'}
            </Label>
          </div>
            </div>
          </Collapsible>
        </div> */}
         
         <div>
          <Collapsible
            trigger={
              <div className="ncss-col-sm-12 collapse-p0">
                <div className="ncss-col-sm-11 collapse-p0"> REMEDIATION INFORMATION</div>
                <div className="ncss-col-sm-1 ">
                  <i className="fas fa-caret-down fa-pull-right" />
                </div>
              </div>
            }
            triggerWhenOpen={
              <div className="ncss-col-sm-12 collapse-p0">
                <div className="ncss-col-sm-11 collapse-p0"> REMEDIATION INFORMATION</div>
                <div className="ncss-col-sm-1">
                  <i className="fas fa-caret-up fa-pull-right" />
                </div>
              </div>
            }
            triggerStyle={style}
            triggerClassName="collapsible"
          >
            <Remediation qrfDetails={qrfDetails} frfDetails={frfDetails} attachment={attachment} attachmentEdit={false}/>
          </Collapsible>
        </div>
      </div>
    );
  }
}

ReviewAndSubmitInfo.propTypes = {
  affectedMaterial: PropTypes.string,
  materialAffectedQty: PropTypes.string,
  materialWorth:PropTypes.string,
  affectedMaterialLeft: PropTypes.string,
  factoryList: PropTypes.string,
  affectedMaterialForKid: PropTypes.string,
  immediateStep: PropTypes.string,
  displaySubmitButtonQrf: PropTypes.func,
  displayClearButtonQrf: PropTypes.func
};
function mapStateToProps(state) {
  return {
    trfResult: state.qrf.trfDetail,
    qrfDetails: {
          qrfId: '',
          leftFacility: get(state, `form.Remediation.values.affectedMaterialLeft`, ''),
          quantity: get(state, `form.Remediation.values.materialAffectedQty`, ''),
          materialWorth: get(state, `form.Remediation.values.materialWorth`, ''),
          futureProduction: get(state, `form.Remediation.values.futureProduction`, '')
          // proposedCorrectiveAction: get(state, `form.Remediation.values.proposedCorrectiveAction`, 
          //   get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '')!== ''? "No" : "")
       
        },
    frfDetails:{
      frfId: get(state.frf.trfDetail, `data.frfDetails.frfId`, ''),
      PDCA: get(state, `form.Remediation.values.PDCA`, get(state.qrf.trfDetail, `data.frfDetails.PDCA`, '')),
      failureDesc: get(state, `form.Remediation.values.failureDesc`, get(state.qrf.trfDetail, `data.frfDetails.failureDesc`, '')),
      //dateOfCompletion: get(state, `form.Remediation.values.dateOfCompletion`, (get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '') && new Date(get(state.frf.trfDetail, `data.frfDetails.dateOfCompletion`, '')))),
      dateOfCompletion: get(state, `form.Remediation.values.dateOfCompletion`,(get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '') && new Date(get(state.qrf.trfDetail, `data.frfDetails.dateOfCompletion`, '')))),
      correctiveAction: get(state, `form.Remediation.values.correctiveAction`, get(state.qrf.trfDetail, `data.frfDetails.correctiveAction`, '')),
      rootCause: get(state, `form.Remediation.values.rootCause`, get(state.qrf.trfDetail, `data.frfDetails.rootCause`, '')),
      guideYes: get(state, `form.Remediation.values.guideYes`,'' ),
      guideNo: get(state, `form.Remediation.values.guideNo`, ''),
      futureProductYes: get(state, `form.Remediation.values.futureProductYes`, ''),
      proposedCorrectiveAction: get(state, `form.Remediation.values.proposedCorrectiveAction`, get(state.qrf.trfDetail, `data.frfDetails.proposedCorrectiveAction`, '')),
      
    }    
  };
}

export default connect(mapStateToProps)(ReviewAndSubmitInfo);
